import React, {useState} from 'react';
import './styles/shopstands.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { motion, AnimatePresence } from 'framer-motion';

const StandDetail = ({id, closepopup}) => {

  const standTransitions = {
    initial: {
      opacity: 0,
    },
    show: {
      opacity: 1,
      transition: {
        duration: 0.2,
        type: 'ease',
      }
    },
    hide: {
      opacity: 0,
      transition:{
        duration: 1,
        type: 'ease',
      }
    }
  }

  return(
    <div className='modal_container'>
      <AnimatePresence>
        <motion.div className='modal_box stand_detail_container'
          initial='initial'
          animate='show'
          exit='hide'
          variants={standTransitions}
        >
            <div className='views_item_details_stand_container'>
              <img src="/img/img_preview.png" className='img_item_stand' alt="" />
              <div className='views_structer_container_stand'>
                <span className='difuser_views_thumbs_box_stand'></span>
                <div className='views_thumbs_box_stand'>
                  <div className='views_thumb_item_stand'></div>
                  <div className='views_thumb_item_stand'></div>
                  <div className='views_thumb_item_stand'></div>
                  <div className='views_thumb_item_stand'></div>
                  <div className='views_thumb_item_stand'></div>
                  <div className='views_thumb_item_stand'></div>
                  <div className='views_thumb_item_stand'></div>
                  <div className='views_thumb_item_stand'></div>
                  <div className='views_thumb_item_stand'></div>
                  <div className='views_thumb_item_stand'></div>
                  <div className='views_thumb_item_stand'></div>
                  <div className='views_thumb_item_stand'></div>
                </div>
              </div>
            </div>
            <div className='info_item_details_stand_container'>
              <div className='header_item_detail_stand_box'>
                <h2>Train Kits</h2>
                <button className='btn_close_popups' onClick={() => closepopup()}><FontAwesomeIcon icon={faXmark} size='2xl'/></button>
              </div>
            </div>
        </motion.div>
      </AnimatePresence>
    </div>
  )
}

export const ShopStands = ({title, descpShort, price, imgToShow, ctaMsg, id, buyAction}) => {
  const [standOpen, setStandOpen] = useState(false)

  const showDetails = () => setStandOpen(true);
  const hideDetails = () => setStandOpen(false);

  return (
    <>
    {standOpen && <StandDetail id={id} closepopup={hideDetails}/>}
    <div className='stand_structer_blackm'>
      <div className='preview_item_stand_container_blackm'>
        <span className='title_item_stand_blackm'>{title}</span>
        <img src={imgToShow} alt={title} className='img_item_stand'/>
        <span className='difuser_visual_item_stand_blackm'></span>
        <span className='caption_item_stand_blackm'>{descpShort}</span>
      </div>
      <div className='footer_and_cta_container_stand_blackm' onClick={buyAction}>
        <span className='amount_item_price_stand_blackm'>{price.split('.0000 ONYX').join('')} onyx</span>
        <span className='cta_msg_stand_blackm'>{ctaMsg}</span>
      </div>
    </div>
    </>
  )
}
